import { Admin } from '@/types/admin';
import { api } from '@/services/api/axios/instance';

type ActivateParams = {
  data: {
    admin: Admin;
    password: string;
    token: string;
  };
};

type ResetPasswordParams = {
  data: {
    password: string;
    token: string;
  };
};

type UpdatePasswordParams = {
  data: {
    currentPassword: string;
    newPassword: string;
  };
};

export const adminsApi = {
  activate: async (config: ActivateParams): Promise<void> => {
    const { password, token, admin } = config.data;
    const params = {
      first_name: admin.firstName,
      last_name: admin.lastName,
      kana_first_name: admin.kanaFirstName,
      kana_last_name: admin.kanaLastName,
      password: password.trim(),
    };

    await api.put('admins/activation', params, {
      headers: {
        'x-v2-admin-activate-token': `Bearer ${token}`,
      },
    });
  },
  resetPassword: async (config: ResetPasswordParams): Promise<void> => {
    const { password, token } = config.data;
    const params = {
      new: password.trim(),
    };

    await api.post('admins/password', params, {
      headers: {
        'x-v2-admin-reset-password-token': `Bearer ${token}`,
      },
    });
  },
  updatePassword: async (config: UpdatePasswordParams): Promise<void> => {
    const { currentPassword, newPassword } = config.data;
    const params = {
      current: currentPassword.trim(),
      new: newPassword.trim(),
    };

    await api.put('admins/me/password', params);
  },
};
